<template>
  <div class="bgs">
    <div class=" mb-6">
      <h2>Destination</h2>
      <v-btn @click="opd = true" class="lead-form-btn mt-4 font-weight-bold" variant="outlined">
        <svg width="12" height="12" class="mr-2" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.99999 0C6.4142 0 6.74999 0.335786 6.74999 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41422 11.6642 6.75 11.25 6.75H6.74999V11.25C6.74999 11.6642 6.4142 12 5.99999 12C5.58578 12 5.24999 11.6642 5.24999 11.25V6.75H0.75C0.335786 6.75 0 6.41422 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.24999V0.75C5.24999 0.335786 5.58578 0 5.99999 0Z"
            fill="#237276" />
        </svg>

        <span>
          Create Lead form</span>
      </v-btn>

    </div>
    <v-row dense>
      <!-- Attachment Type -->
      <v-col cols="12" class="d-flex align-center mb-4">
        <div class="label tit">
          Attachment Type <span class="required">*</span>
        </div>

        <input type="text" class="border pa-3 mr-6 rounded" id="campaignObjective" placeholder="Lead form" value="Lead form"
          style="color: #333333" readonly />

        <!-- Lead Forms Dropdown -->
        <LeadsSearch ref="leadsSearchRef" />
      </v-col>

      <!-- Call To Action -->
      <v-col cols="12" class="d-flex align-center mb-4">
        <div class="label tit">
          Call to action <span class="required">*</span>
        </div>
        <v-select v-model="store.ad_call_to_action_type" :items="ctaOptions" item-title="label" item-value="value"
          placeholder="Select call to action" variant="outlined" density="comfortable" hide-details class="flat-select"
          :class="{ 'has-error': submitted && !store.ad_call_to_action_type }" />
      </v-col>

      <!-- Website URL -->
      <v-col cols="12" class="d-flex align-center mb-4">
        <div class="label tit">Website url <span class="required">*</span></div>
        <v-text-field v-model="store.websiteUrlLeeds" placeholder="Enter website URL" variant="outlined"
          density="comfortable" hide-details class="flat-select"
          :class="{ 'has-error': submitted && !store.websiteUrlLeeds }" />
      </v-col>
      <CreateLeedForm v-if="opd" v-model:dialog="opd" />
    </v-row>
  </div>

</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
import LeadsSearch from "@/components/SuperApp/LeadsSearch.vue";
import CreateLeedForm from "./Awareness/StepTree/CreateLeedForm.vue";
export default {
  components: { LeadsSearch, CreateLeedForm },
  data() {
    return {
      store: useSuperAddStore(),
      submitted: false,
      errors: [],
      opd: false,
      ctaOptions: [
        { label: "Apply now", value: "APPLY_NOW" },
        { label: "Book Now", value: "BOOK_NOW" },
        { label: "Sign Up", value: "SIGN_UP" },
      ],
    };
  },
  methods: {
    validate() {
      this.submitted = true;
      const errors = [];

      if (!this.store.websiteUrlLeeds || !this.validUrl(this.store.websiteUrlLeeds)) {
        errors.push(" Website URL is required and must be valid");
      }

      if (!this.store.ad_call_to_action_type) {
        errors.push(" Call to action is required");
      }

      const formErrors = Array.isArray(this.$refs.leadsSearchRef?.validate?.())
        ? this.$refs.leadsSearchRef.validate()
        : [];

      this.errors = [...errors, ...formErrors];
      return this.errors;
    },
    validUrl(url) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // http:// or https://
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$", "i"
      );
      return !!pattern.test(url);
    }
    ,
    getData() {
      return {
        attachmentType: "Lead form",
        websiteUrl: this.store.websiteUrlLeeds,
        cta: this.store.ad_call_to_action_type,
        ...(this.$refs.leadsSearchRef?.getData?.() || {}),
      };
    },
  },
};
</script>

<style scoped>
.lead-form-btn {
  min-height: 3rem;
  border: 1px solid #237276;
  color: #237276;
  border-radius: 8px;
  display: flex;
}

.bgs {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin: 2rem 0;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
}

.required {
  color: red;
}


.input-box {
  border-radius: 6px;
  min-width: 250px;
  margin-right: 12px;
  min-height: 2rem;
}

.flat-select .v-field {
  background-color: transparent !important;
  border-radius: 6px;
}

.tit {
  min-width: 14rem;
}

.has-error input,
.has-error .v-field,
.has-error .v-input__control {
  border-color: red !important;
  color: red !important;
}
</style>
